import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/pings',
    component: () =>
      interopDefault(
        import(/* webpackChunkName: 'employee:pings' */ '~/pages/employee/pings/index.vue')
      ),
    children: [
      {
        path: '',
        name: RouteEnum.PINGS.INTERNAL,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'employee:pings.internal' */ '~/pages/employee/pings/internal/index.vue'
            )
          ),
      },
      {
        path: 'external',
        name: RouteEnum.PINGS.EXTERNAL,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'employee:pings.external' */ '~/pages/employee/pings/external/index.vue'
            )
          ),
      },
    ],
  },
];
